import Vue from "vue";
import App from "./App.vue";
require("../../node_modules/typeface-overpass/index.css");
require("../../node_modules/normalize.css/normalize.css");

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
